module.exports = {
    "breadcrumbs": `Navigacijski putovi`
};


//# sourceMappingURL=hr-HR.main.js.map
